import { inject, provideAppInitializer, Type } from '@angular/core';

import { AsyncInit } from './async-init';

/**
 * Runs a service's async `init()` before the application starts.
 *
 * Replaces the APP_INITIALIZER multi-provider the NgModule used, deprecated since v19: the service
 * is resolved with `inject()` inside the initializer rather than declared as a `deps` array.
 */
export function provideAsyncInit<T extends AsyncInit>(serviceClass: Type<T>) {
  return provideAppInitializer(() => inject(serviceClass).init());
}
